import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Stack, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import PrintIcon from '@mui/icons-material/Print'
import { showFormModal, setSnackBar } from 'state/ui'
import { request } from 'customRequest'
import useQzTray from 'utils/custom-hooks/useQzTray'
import printJS from 'print-js'
import rem from 'utils/rem'
import FORM_MODALS from 'utils/ui/modals'
import Loading from 'components/generic/Loading'

const InvoiceConfirmationModal = ({ onFormStateChange, onHideModal }) => {
  const dispatch = useDispatch()
  const {
    invoiceId,
    invoiceData,
    // FIXME: GREEN-12685 remove everything below here when removing FF (no more FE PDFs)
    selectedOutboundTickets,
    salesOrderData,
    customerData,
    priceSheetsData,
    priceSheet,
    summaryData,
    totalAmountPaid,
    pricePrepend,
  } = useSelector(state => state.ui.formModalProps)

  const { enableFePdfs, enableInvoiceContainerV2 } = useSelector(state => state.featureFlags?.variables || {})
  const { qzPrint } = useQzTray()
  const [isFetchingPdf, setIsFetchingPdf] = useState(false)

  useEffect(() => {
    onFormStateChange(false)
  }, [])

  return (
    <>
      {isFetchingPdf && <Loading />}
      <Stack alignItems="center" p={10} spacing={3}>
        <Stack direction="row" mt={10} spacing={2}>
          <CheckCircleIcon color="primary" sx={{ fontSize: rem(35) }} />
          <Typography variant="h4">{`Invoice #${invoiceId} Created`}</Typography>
        </Stack>
        <Typography variant="h5">What would you like to do next?</Typography>
        <Stack spacing={2}>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={async () => {
              // FIXME: GREEN-12685 remove this (no more FE PDFs)
              if (!enableFePdfs && !enableInvoiceContainerV2) {
                dispatch(
                  showFormModal({
                    formModalName: FORM_MODALS.INVOICE_PRINT,
                    formModalProps: {
                      formTitle: `Invoice #${invoiceId} | Unpaid`,
                      invoiceData,
                      selectedOutboundTickets,
                      salesOrderData,
                      customerData,
                      priceSheetsData,
                      priceSheet,
                      summaryData,
                      totalAmountPaid,
                      pricePrepend,
                    },
                  }),
                )
                return
              }

              if (!invoiceData?.id) {
                return
              }

              setIsFetchingPdf(true)
              const pdfUrl = `/core-api/sales/invoices/${invoiceData.id}/pdf/INVOICE`
              const documentTitle = `Invoice #${invoiceData?.invoiceTicketId}`

              try {
                const response = await request(pdfUrl, 'get', {}, { accept: 'application/pdf' }, true)
                const documentPrinter = localStorage.getItem('documentPrinter')

                if (!documentPrinter || documentPrinter === 'none') {
                  printJS({
                    printable: response,
                    type: 'pdf',
                    base64: true,
                    documentTitle,
                  })
                } else {
                  await qzPrint(response, documentPrinter).catch(() => {
                    printJS({
                      printable: response,
                      type: 'pdf',
                      base64: true,
                      documentTitle,
                    })
                  })
                }
              } catch (error) {
                dispatch(
                  setSnackBar({
                    snackbarType: 'error',
                    snackbarMessage: `This is the error ${error}`,
                  }),
                )
              } finally {
                setIsFetchingPdf(false)
              }
            }}
          >
            PRINT
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              onHideModal()
            }}
          >
            FINISH
          </Button>
        </Stack>
      </Stack>
    </>
  )
}

InvoiceConfirmationModal.propTypes = {
  onFormStateChange: PropTypes.func,
  onHideModal: PropTypes.func,
}

InvoiceConfirmationModal.defaultProps = {
  onFormStateChange: noop,
  onHideModal: null,
}

export default InvoiceConfirmationModal
